import { createFileRoute } from '@tanstack/react-router'
import WebhooksPage from '@/pages/dashboard/webhooks-page'
import { ProtectedRoute, RequireModule } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'
import { MODULES } from '@/constants/modules'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/sistema/webhooks',
)({
  component: function WebhooksRoute() {
    const { dashboardId } = Route.useParams()
    
    return (
      <RequireModule module={MODULES.WEBHOOKS} dashboardId={dashboardId}>
        <ProtectedRoute capability={CAPABILITIES.MANAGE_DASHBOARD_CONFIG}>
          <WebhooksPage />
        </ProtectedRoute>
      </RequireModule>
    )
  },
})
